import React from "react";

const MaterialIntro = props => (
  <div className="container">
    <h1 className="title is-2 has-text-light">{props.title}</h1>
    <p className="has-text-light is-hidden">{props.intro}</p>
  </div>
);

export default MaterialIntro;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/MaterialIntro.js